import { automationApi } from 'nove8/api'
import {
  DEFAULT_WOOFY_CHAT_API_VERSION,
  ProcessingKey,
  TWoofyChatApiVersion,
} from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const getWoofyCreative = async ({
  creativeId,
  apiVersion = DEFAULT_WOOFY_CHAT_API_VERSION,
}: {
  creativeId: string
  apiVersion?: TWoofyChatApiVersion
}): Promise<void> => {
  useZustandStore
    .getState()
    .startProcessing(ProcessingKey.AUTOMATION_WOOFY_GET_CREATIVE)

  try {
    const result = await automationApi.getWoofyCreative({
      creativeId,
      apiVersion,
    })

    if (result.success && result.data) {
      useZustandStore.setState({ woofyCreative: result.data })
    } else {
      throw new Error('getWoofyCreative failed')
    }
  } finally {
    useZustandStore
      .getState()
      .stopProcessing(ProcessingKey.AUTOMATION_WOOFY_GET_CREATIVE)
  }
}
